import { CascadeMenu } from '@aibees/elephant/components/cascade-menu';
import { ROUTES as R } from '@aibees/elephant/router';
import { LabelGrouping } from '@aibees/elephant/types/label';
import { IconButton } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils/class-names';
import { memo, useCallback, useMemo } from 'react';
import { type LabelSearchTableActionProps as Props } from './types';

const CASCADE_ITEMS = [
  {
    key: 'include',
    label: 'Include',
    icon: 'add-circle-outlined' as const,
    iconColor: 'primary.500',
  },
  {
    key: 'exclude',
    label: 'Exclude',
    icon: 'stop-sign' as const,
    iconColor: 'error.500',
  },
  {
    key: 'include_and',
    label: 'Include (AND)',
    icon: 'add-task' as const,
    iconColor: 'warning.500',
  },
];

const URL_KEY: Record<string, { company: string; people: string }> = {
  include: {
    company: 'labels_account_include',
    people: 'labels_contact_include',
  },
  exclude: {
    company: 'labels_account_exclude',
    people: 'labels_contact_exclude',
  },
  include_and: {
    company: 'companies_all_of_labels',
    people: 'people_all_of_labels',
  },
};

export const LabelSearchTableAction = memo(({ className, item }: Props) => {
  const handleSelect = useCallback(
    (parentKey: string) => {
      const subKey =
        item.grouping === LabelGrouping.COMPANY ? 'company' : 'people';
      const urlKey = URL_KEY[parentKey]?.[subKey];
      if (!urlKey) return;
      const route = subKey === 'company' ? R.searchCompany : R.searchPeople;
      const value = encodeURIComponent(
        `${item.name}::${encodeURIComponent(item.id)}`
      );
      window.open(`${route}?${urlKey}=${value}`, '_blank');
    },
    [item]
  );

  const trigger = useMemo(
    () => <IconButton icon="eye-outlined" variant="outlined" size="xsmall" />,
    []
  );

  return (
    <CascadeMenu
      className={classnames('LabelSearchTableAction', className)}
      items={CASCADE_ITEMS}
      onSelect={handleSelect}
      buttonElement={trigger}
    />
  );
});

LabelSearchTableAction.displayName = 'LabelSearchTableAction';
